interface Props {
  [key: string]: any
}

export default function ArrowDownBoldIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 57 84" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M31.7429 82.7412L55.7436 58.7405C57.0502 57.4339 57.0502 55.3171 55.7436 54.0105L50.9852 49.2521C49.6786 47.9455 47.5617 47.9455 46.2551 49.2521L22.2524 73.2548C20.9458 74.5614 20.9458 76.6783 22.2524 77.9849L27.0108 82.7433C28.3174 84.0478 30.4363 84.0478 31.7429 82.7412Z"
        fill="white"
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M36.4665 3.70264L36.4665 77.6414L20.2607 73.0835L20.2607 3.70264C20.2607 2.02535 21.622 0.664065 23.2993 0.664065L33.4279 0.664065C35.1052 0.664065 36.4665 2.02535 36.4665 3.70264Z"
        fill="white"
      />
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M27.0074 82.7412L0.980917 56.7128C-0.325672 55.4062 -0.325672 53.2893 0.980916 51.9827L5.73933 47.2243C7.04592 45.9177 9.16279 45.9177 10.4694 47.2243L36.4634 73.2204L36.4634 78.0173L31.7374 82.7433C30.4328 84.0478 28.3139 84.0478 27.0074 82.7412Z"
        fill="white"
      />
    </svg>
  )
}
